import React, { useState } from "react";
import ReasonsForCanceling from "./ReasonsForCanceling";
import Constants from "../constants/Constants";
const POPUP_CLASS = "show_popup";
const ManageMembershipItem = ({ site, user, dispatch, i }) => {
  const [isCanceling, setIsCanceling] = useState(
    user.biller_expires === "0" ? false : true
  );
  const [error, setError] = useState("");
  const [showReasons, setShowReasons] = useState(false);
  const changeMembership = () => {
    let formData = new FormData();
    formData.append("m", user.memID);
    formData.append("siteid", user.siteid);
    if (isCanceling) {
      fetch(`${Constants.API}reactivate.php`, {
        credentials: "include",
        method: "POST",
        body: formData,
      })
        .then((res) => res.json())
        .then((res) => {
          if (!("error" in res)) {
            setIsCanceling(false);
            dispatch({
              type: "setMemToExpire",
              payload: parseInt(i),
              timeVal: 0,
            });
          } else {
            setError("Please contact support something went wrong...");
          }
        })
        .catch((error) => console.log("handling error", error));

      return;
    }

    setShowReasons(true);
    setTimeout(() => {
      document.body.classList.add(POPUP_CLASS);
    }, 100);
    // fetch(`${Constants.API}cancelmembership.php`, {
    //   credentials: "include",
    //   method: "POST",
    //   body: formData
    // })
    //   .then(res => res.json())
    //   .then(res => {
    //     if (!("error" in res)) {
    //       setIsCanceling(true);
    //       dispatch({
    //         type: "setMemToExpire",
    //         payload: parseInt(i),
    //         timeVal: 1559494639
    //       });
    //     } else {
    //       setError("Please contact support something went wrong...");
    //     }
    //   });
    //Cancel
  };
  return (
    <div className="item_thumb">
      <div className="photo_thumb">
        <img
          src={`https://addfriends.com/images/friends/${site.site_url}-sm.jpg`}
          alt=""
        />
      </div>
      <div className="content_thumb">
        <a
          href={user.biller_support}
          target="_blank"
          rel="noopener noreferrer"
          className="btn"
        >
          Click for support
        </a>
        <div className="info">
          <ul>
            <li>Friend</li>
            <li>
              <strong>{site.site_name}</strong>
            </li>
          </ul>
          <ul>
            <li>Private Account</li>
            <li>
              <strong>{user.snapname}</strong>
            </li>
          </ul>
          <div
            className={
              isCanceling ? "select_section reactive" : "select_section"
            }
          >
            <span className="view_text">
              {isCanceling ? "Canceling" : "Active"}
            </span>
            <button
              type="button"
              className="button_check"
              onClick={changeMembership}
            >
              {isCanceling ? "Re-Activate" : "Cancel Membership"}
            </button>
          </div>
          {error ? (
            <div className="error">
              Contact support there was a issue in canceling.
            </div>
          ) : null}
        </div>
      </div>
      {showReasons ? (
        <ReasonsForCanceling
          model={site}
          i={i}
          setIsCanceling={setIsCanceling}
          setShowReasons={setShowReasons}
          setError={setError}
          dispatch={dispatch}
          user={user}
        />
      ) : null}
    </div>
  );
};

export default ManageMembershipItem;
